<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.in_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="in_type">
            <label class="weui-form-preview__label">{{customLabel.in_type || "询价类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.in_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="in_startdate">
            <label class="weui-form-preview__label">{{customLabel.in_startdate || "询价日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.in_startdate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="in_enddate">
            <label class="weui-form-preview__label">{{customLabel.in_enddate || "截止日期"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.in_enddate
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.in_text1 || '自定义字段1'"
          v-model="form.main.in_text1" slot="in_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.in_text2 || '自定义字段2'"
          v-model="form.main.in_text2" slot="in_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.in_text3 || '自定义字段3'"
          v-model="form.main.in_text3" slot="in_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.in_text4 || '自定义字段4'"
          v-model="form.main.in_text4" slot="in_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.in_text5 || '自定义字段5'"
          v-model="form.main.in_text5" slot="in_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ind_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div
              class="weui-form-preview__item" slot="ind_vendname"
              v-if="form.main.in_type == '定向询价'"
            >
              <label class="weui-form-preview__label">{{customLabel.ind_vendname || "供应商"}}</label>
              <em class="weui-form-preview__value">{{
                item.ind_vendname
              }}</em>
            </div>
            <div
              class="weui-form-preview__item" slot="ind_contact"
              v-if="form.main.in_type == '定向询价'"
            >
              <label class="weui-form-preview__label">{{customLabel.ind_contact || "联系人"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.ind_contact }} {{ item.ind_tel }}
                <call-mobile :mobile="item.ind_tel"></call-mobile>
              </span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div
              class="weui-form-preview__item" slot="pr_orispeccode"
              v-if="item.productDTO.pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div
              class="weui-form-preview__item" slot="pr_brand"
              v-if="item.productDTO.pr_brand"
            >
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_brand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ind_planqty">
              <label class="weui-form-preview__label">{{customLabel.ind_planqty || "需求数量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.ind_planqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="ind_currency">
              <label class="weui-form-preview__label">{{customLabel.ind_currency || "币种"}}</label>
              <span class="weui-form-preview__value">
                {{ item.ind_currency }}
                <span v-if="item.ind_rate && item.ind_rate != 1">
                  / {{ item.ind_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.ind_remark" slot="ind_remark">
              <label class="weui-form-preview__label">{{customLabel.ind_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{
                item.ind_remark
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ind_text1 || '自定义字段1'"
            v-model="item.ind_text1" slot="ind_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ind_text2 || '自定义字段2'"
            v-model="item.ind_text2" slot="ind_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ind_text3 || '自定义字段3'"
            v-model="item.ind_text3" slot="ind_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ind_text4 || '自定义字段4'"
            v-model="item.ind_text4" slot="ind_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ind_text5 || '自定义字段5'"
            v-model="item.ind_text5" slot="ind_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.main.in_remark">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.in_remark
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/purchase/inquiry_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/purchase/inquiry",
      codeField: "in_code",
      statusField: "in_statuscode",
      caller: "PurchaseInquiry",
      xtype: "purchase-b2b-inquiry-formpanel",
    };
  },
};
</script>